var map = {
	"./template.bet575": 1747,
	"./template.bet575.tsx": 1747,
	"./template.bet777": 1748,
	"./template.bet777.tsx": 1748,
	"./template.betprofessor": 1749,
	"./template.betprofessor.tsx": 1749,
	"./template.betroyale": 1750,
	"./template.betroyale.tsx": 1750,
	"./template.betstride": 1751,
	"./template.betstride.tsx": 1751,
	"./template.buffalobet": 1752,
	"./template.buffalobet.tsx": 1752,
	"./template.chromabet": 1753,
	"./template.chromabet.tsx": 1753,
	"./template.default": 715,
	"./template.default.tsx": 715,
	"./template.epicodds": 1754,
	"./template.epicodds.tsx": 1754,
	"./template.fiestabet": 1755,
	"./template.fiestabet.tsx": 1755,
	"./template.forsport": 1756,
	"./template.forsport.tsx": 1756,
	"./template.gigabet": 1757,
	"./template.gigabet.tsx": 1757,
	"./template.goldenbet888": 1758,
	"./template.goldenbet888.tsx": 1758,
	"./template.goldenrush": 1759,
	"./template.goldenrush.tsx": 1759,
	"./template.hyperbet": 1760,
	"./template.hyperbet.tsx": 1760,
	"./template.juicybet": 1761,
	"./template.juicybet.tsx": 1761,
	"./template.junglebet": 1762,
	"./template.junglebet.tsx": 1762,
	"./template.magnumbet": 1763,
	"./template.magnumbet.tsx": 1763,
	"./template.oldgill": 1764,
	"./template.oldgill.tsx": 1764,
	"./template.puntcity": 1765,
	"./template.puntcity.tsx": 1765,
	"./template.puntgenie": 1766,
	"./template.puntgenie.tsx": 1766,
	"./template.pyramidbet": 1767,
	"./template.pyramidbet.tsx": 1767,
	"./template.questbet": 1768,
	"./template.questbet.tsx": 1768,
	"./template.slambet": 1769,
	"./template.slambet.tsx": 1769,
	"./template.sterlingparker": 1770,
	"./template.sterlingparker.tsx": 1770,
	"./template.templebet": 1771,
	"./template.templebet.tsx": 1771,
	"./template.titanbet": 1772,
	"./template.titanbet.tsx": 1772,
	"./template.ts": 990,
	"./template.vikingbet": 1773,
	"./template.vikingbet.tsx": 1773,
	"./template.volcanobet": 1774,
	"./template.volcanobet.tsx": 1774,
	"./template.wellbet": 1775,
	"./template.wellbet.tsx": 1775
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2479;